import * as React from 'react';
import TreeView from '@mui/lab/TreeView';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TreeItem from '@mui/lab/TreeItem';
import GenericContent from '../components/GenericContent';
import LeafContent from '../components/LeafContent';
import { Box } from '@mui/material';


const StableBuildTreeFix = (stableBuild) => {

function GenericTreeItem(props) {
  return <TreeItem ContentComponent={GenericContent} {...props} />;
};

function LeafTreeItem(props) {
  return <TreeItem ContentComponent={LeafContent} {...props} />;
};

const handleTreeItemClick = (node) => {
  if (node.link !== undefined){
    if (node.link === '' || node.link === 'NA'){
      alert('No image information');
    }else{
      window.open(node.link, "_blank");
    }
  }
};

  const renderStableTree = (nodes) => {
    switch (nodes.header) {
      case 'leaf':
        return (<LeafTreeItem key={nodes.label} nodeId={nodes.label ? nodes.label : "defaultNodeId"} label={nodes.label} onClick={() => handleTreeItemClick(nodes)}>
                  {Array.isArray(nodes.children)
                    ? nodes.children.map((node) => renderStableTree(node))
                    : null}
                </LeafTreeItem>);

      default:
        return (<GenericTreeItem key={nodes.label} nodeId={nodes.label ? nodes.label : "defaultNodeId"} label={nodes.label} sx={{ fontFamily: '"Roboto", "sans-serif"' }}>
                  {Array.isArray(nodes.children)
                    ? nodes.children.map((node) => renderStableTree(node))
                    : null}
                </GenericTreeItem>);
    }
  };

  const renderNewTree = (nodes) => {
    switch (nodes.header) {
      case 'leaf':
        return (<LeafTreeItem key={nodes.label} nodeId={nodes.label ? nodes.label : "defaultNodeId"} label={nodes.label} onClick={() => handleTreeItemClick(nodes)}>
                  {Array.isArray(nodes.children)
                    ? nodes.children.map((node) => renderNewTree(node))
                    : null}
                </LeafTreeItem>);

      default:
        return (<GenericTreeItem key={nodes.label} nodeId={nodes.label ? nodes.label : "defaultNodeId"} label={nodes.label}  sx={{ fontFamily: '"Roboto", "sans-serif"' }}>
                  {Array.isArray(nodes.children)
                    ? nodes.children.map((node) => renderNewTree(node))
                    : null}
                </GenericTreeItem>);
    }
  };

  return (
    <Box sx={{ paddingLeft: '70px' }}>
      <TreeView
        aria-label="rich object"
        defaultCollapseIcon={<ExpandMoreIcon />}
        defaultExpanded={['Stable builds','Version:','URL:','APP:','BLAPP:','F103:','L485:']}
        defaultExpandIcon={<ChevronRightIcon />}
        sx={{ overflowY: 'auto',fontFamily: '"Roboto", "sans-serif"' }}
      >
        {renderStableTree(stableBuild.stableBuild)}
      </TreeView>
      <TreeView
        aria-label="rich object"
        defaultCollapseIcon={<ExpandMoreIcon />}
        defaultExpanded={['New Versions','Version:','URL:','APP:','BLAPP:','F103:','L485:']}
        defaultExpandIcon={<ChevronRightIcon />}
        sx={{ overflowY: 'auto',fontFamily: '"Roboto", "sans-serif"', marginTop: "15px" }}
      >
        {renderNewTree(stableBuild.newBuild)}
      </TreeView>
    </Box>
  );
};

export default StableBuildTreeFix;

